import { GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAIL, LOGOUT, GET_ALL_ROLES_REQUEST } from "../actions/types";

const initialState = { roles: null, loading: false, error: null };

export const getAllRolesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_ROLES_REQUEST:
      return {
        ...state,

        roles: null,
        loading: true,
      };
    case GET_ALL_ROLES_SUCCESS:
      return {
        ...state,
        roles: payload,
        loading: false,
      };
    case GET_ALL_ROLES_FAIL:
      return {
        ...state,
        roles: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     roles: false,
    //     user: null,
    //   };
    default:
      return state;
  }
};
